var scope_0 = require('/opt/render/project/src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2c9e4de93f6d2cceab2a55ba80359758.js').default;
var scope_1 = require('/opt/render/project/src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4520ce9cb6b819b450c28d52f14c1080.js').default;
var scope_2 = require('/opt/render/project/src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/84e65808e9d2b46b8053c77d9881781e.js').default;
var scope_3 = require('/opt/render/project/src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a375aed5d5f5ba6229281739c83ef4dc.js').default;
var scope_4 = require('/opt/render/project/src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b7f8ac76662b915db73b58c1e1179b5d.js').default;
var scope_5 = require('/opt/render/project/src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ca1c525c5d3d2f0b7cd0b98e2a3c6c12.js').default;
var scope_6 = require('/opt/render/project/src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d93bcfa3c6b4e7038cf67dd8d65dbb1b.js').default;
var scope_7 = require('/opt/render/project/src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ed247a86b72caabfcc178c68dba5a387.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7 )
    